import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { URLLoader } from 'src/app/main/configs/URLLoader';
import MemberMessage from 'src/app/main/messages/MemberMessage';
import MemberTestService from 'src/app/main/mocks/MemberTestService';
import { HTTPService } from 'src/app/main/services/HTTPService';
import CONFIG from 'src/app/main/urls/urls';
import MemberValidation from 'src/app/main/validations/MemberValidation';

@Component({
  selector: 'app-add-member',
  templateUrl: './add-member.component.html',
  styleUrls: ['./add-member.component.css'],
})
export class AddMemberComponent extends URLLoader implements OnInit {
  memberForm: FormGroup;
  msg: MemberMessage;
  submitted = false;
  @Output() closeModalEvent = new EventEmitter<string>();
  memberI18n;

  closeModal() {
    this.closeModalEvent.emit();
  }

  goBack() {
    /* this.router
      .navigateByUrl('/dashboard', { skipLocationChange: true })
      .then(() => {
        this.router.navigate(['/member']);
      }); */
  }

  get f() {
    return this.memberForm.controls;
  }

  reset() {
    this.memberForm.reset();
  }

  getMemberByLang(lang) {
     lang='EN'
    this.httpService.getAll(CONFIG.URL_BASE + '/i18n/member/' + lang).subscribe(
      (data) => {
        this.memberI18n = data;
        console.log(this.memberI18n);
      },
      (err: HttpErrorResponse) => {
        super.show('Error', err.message, 'error');
      }
    );
  }

  add() {
    this.submitted = true;

    if (this.validateMemberForm(this.memberForm.value)) {
      this.httpService
        .create(CONFIG.URL_BASE + '/member/create', this.memberForm.getRawValue())
        .finally(() => {
          this.reset();
          this.closeModal();
          this.goBack();
          this.toastr.success('Item added successfully!', 'Success');
        });
    }
  }

  constructor(private toastr: ToastrService,private fb: FormBuilder, private tooltipConfig: NgbTooltipConfig,private validation: MemberValidation,
    private message: MemberMessage,
    private router: Router,
    private httpService: HTTPService) {
      super()
    // Configure tooltips globally
    tooltipConfig.placement = 'right';
    tooltipConfig.triggers = 'hover';

    // Initialize the form group and form controls
    this.memberForm = this.fb.group({
      surname: ['', [Validators.required, Validators.maxLength(99)]],
      firstname: ['', [Validators.required, Validators.maxLength(99)]],
      dob: [''],
      age: [{ value: '', disabled: true }],
      gender: [''],
      admission_number: ['', Validators.required],
      class: ['', Validators.required],
      headOfDepartment: [''],
      address: [''],
      primary_phone: [''],
      primary_email: [''],
    });

    // Auto-calculate age whenever DOB changes (DOB itself stays optional)
    this.memberForm.get('dob').valueChanges.subscribe((dob) => {
      if (dob) {
        this.calculateAge(dob);
      } else {
        this.memberForm.get('age').setValue('', { emitEvent: false });
      }
    });
  }

  calculateAge(dob: string) {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    this.memberForm.get('age').setValue(`${age} years`, { emitEvent: false });
  }

  ngOnInit(): void {
    // Initialization code
  }

  onSubmit(): void {
    const formData = this.memberForm.value;
    console.log('Form Submitted', formData);
    this.add()
  }

  onCancel(){}

  resetForm(): void {
    this.memberForm.reset({
      surname: '',
      firstname: '',
      dob: '',
      age: '',
      gender: '',
      admission_number: '',
      class: '',
      headOfDepartment: '',
      address: '',
      primary_phone: '',
      primary_email: '',
    });
  }

  errors:any
  validateMemberForm(form: any): boolean {
    this.errors = {};
    this.submitted = true;

    // Validate Surname
    if (!form.surname || form.surname.trim().length < 2) {
      this.errors.surname = 'Surname is required and must be at least 2 characters long.';
      this.toastr.error(this.errors.surname, 'Validation Error');
    }

    // Validate First Name
    if (!form.firstname || form.firstname.trim().length < 2) {
      this.errors.firstname = 'First Name is required and must be at least 2 characters long.';
      this.toastr.error(this.errors.firstname, 'Validation Error');
    }

    // Validate Admission Number
    if (!form.admission_number || form.admission_number.trim().length < 1) {
      this.errors.admission_number = 'Admission Number is required.';
      this.toastr.error(this.errors.admission_number, 'Validation Error');
    }

    // Validate Class
    if (!form.class || form.class.trim().length < 1) {
      this.errors.class = 'Class is required.';
      this.toastr.error(this.errors.class, 'Validation Error');
    }

    // Head of Department, Address, Primary Phone, Primary Email,
    // DOB, Age, and Gender are all optional - no validation required

    // Optional: still check email format IF the user entered something
    if (form.primary_email && !this.validateEmail(form.primary_email)) {
      this.errors.primary_email = 'Primary Email must be a valid email address if provided.';
      this.toastr.error(this.errors.primary_email, 'Validation Error');
    }

    return Object.keys(this.errors).length === 0;
  }
  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}